import React from "react";
import { formatNumber2 } from "utils/currencyFormat";
import { BieuDoDonut } from "components/GenericComponent/BieuDoDonut";
import { dinhDangSo } from "../LoiNhuan/periodUtils";

const CAO_BIEU_DO = 250;
const DAY_VANH_DONUT = 42;

const MAU_TANG = "#0E9384";
const MAU_GIAM = "#D92D4E";
const MAU_CHU = "#2B335E"; // .color7
const MAU_PHU = "#5A6081";

/** Bảng màu dùng chung cho toàn bộ biểu đồ tròn của màn hình */
const BANG_MAU = [
  "#2a78d6",
  "#00B69B",
  "#FFA23A",
  "#FF5170",
  "#7E57C2",
  "#26A0FC",
  "#F2C94C",
  "#020f22",
];

const customStyles = `
  .khgt-bieu-do .khgt-tong-tam {
      font-size: 26px;
      font-weight: 700;
      line-height: 1.15;
      color: ${MAU_CHU};
  }
  .khgt-bieu-do .khgt-mo-ta-tam {
      font-size: 12px;
      color: ${MAU_PHU};
  }
  .khgt-bang {
      width: 100%;
      font-size: 12.5px;
      border-collapse: collapse;
  }
  .khgt-bang th {
      color: ${MAU_PHU};
      font-weight: 700;
      text-align: right;
      padding: 4px 6px;
      border-bottom: 1px solid #e3e6f0;
      white-space: nowrap;
  }
  .khgt-bang th:first-child, .khgt-bang td:first-child {
      text-align: left;
      white-space: normal;
  }
  .khgt-bang td {
      text-align: right;
      padding: 4px 6px;
      border-bottom: 1px solid #f4f5f8;
      color: ${MAU_CHU};
      white-space: nowrap;
  }
  .khgt-bang tr:last-child td { border-bottom: none; }
  .khgt-cham {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 3px;
      margin-right: 6px;
      vertical-align: middle;
  }
`;

export const BieuDoTronKhachHang = ({
  tieuDe,
  duLieu,
  nhanKyNay,
  nhanKyTruoc,
  loading,
}) => {
  const danhSach = duLieu || [];
  const tongKyNay = danhSach.reduce((tong, item) => tong + item.kyNay, 0);
  const tongKyTruoc = danhSach.reduce((tong, item) => tong + item.kyTruoc, 0);

  const duLieuBieuDo = danhSach.map((item, i) => ({
    ten: item.ten,
    giaTri: item.kyNay,
    mau: BANG_MAU[i % BANG_MAU.length],
  }));

  /** % tăng/giảm so với kỳ trước; kỳ trước bằng 0 thì không chia được nên báo "Mới" */
  const renderTangTruong = (kyNay, kyTruoc) => {
    if (kyTruoc === 0) {
      if (kyNay === 0) return <span style={{ color: MAU_PHU }}>-</span>;
      return <span style={{ color: MAU_TANG }}>Mới ▲</span>;
    }
    const phanTram = ((kyNay - kyTruoc) / kyTruoc) * 100;
    if (phanTram === 0) return <span style={{ color: MAU_PHU }}>0%</span>;
    return (
      <span style={{ color: phanTram > 0 ? MAU_TANG : MAU_GIAM }}>
        {phanTram > 0 ? "+" : "-"}
        {dinhDangSo(Math.abs(phanTram), 1)}%
        {phanTram > 0 ? " ▲" : " ▼"}
      </span>
    );
  };

  return (
    <div
      className="khgt-bieu-do"
      style={{ display: "flex", flexDirection: "column" }}
    >
      <style>{customStyles}</style>
      <h4 className="interest-rate-title" style={{ flexShrink: 0 }}>
        {tieuDe}
      </h4>

      <BieuDoDonut
        duLieu={duLieuBieuDo}
        chieuCao={CAO_BIEU_DO}
        dayVanh={DAY_VANH_DONUT}
        loading={loading}
        nguongNhan={0.05}
        dinhDangNhan={(value, ratio) => `${(ratio * 100).toFixed(1)}%`}
        dinhDangTooltip={(value, ratio) =>
          `${formatNumber2(value)} HĐ (${(ratio * 100).toFixed(1)}%)`
        }
        thongBaoTrong="Không có hợp đồng mới trong kỳ"
        noiDungTam={
          <>
            <div className="khgt-tong-tam">{formatNumber2(tongKyNay)}</div>
            <div className="khgt-mo-ta-tam">hợp đồng mới</div>
          </>
        }
      />

      <div style={{ marginTop: 8, overflowX: "auto" }}>
        <table className="khgt-bang">
          <thead>
            <tr>
              <th>Nhóm</th>
              <th>{nhanKyNay || "Kỳ này"}</th>
              <th>{nhanKyTruoc || "Kỳ trước"}</th>
              <th>Tăng trưởng %</th>
            </tr>
          </thead>
          <tbody>
            {danhSach.map((item, i) => (
              <tr key={item.ten}>
                <td>
                  <span
                    className="khgt-cham"
                    style={{ backgroundColor: BANG_MAU[i % BANG_MAU.length] }}
                  />
                  {item.ten}
                </td>
                <td style={{ fontWeight: 700 }}>
                  {loading ? "..." : formatNumber2(item.kyNay)}
                </td>
                <td>{loading ? "..." : formatNumber2(item.kyTruoc)}</td>
                <td>
                  {loading
                    ? "..."
                    : renderTangTruong(item.kyNay, item.kyTruoc)}
                </td>
              </tr>
            ))}
            <tr>
              <td style={{ fontWeight: 700 }}>Tổng cộng</td>
              <td style={{ fontWeight: 700 }}>
                {loading ? "..." : formatNumber2(tongKyNay)}
              </td>
              <td style={{ fontWeight: 700 }}>
                {loading ? "..." : formatNumber2(tongKyTruoc)}
              </td>
              <td>
                {loading ? "..." : renderTangTruong(tongKyNay, tongKyTruoc)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
